/**
 * Utilitários para normalização de números de telefone
 * Garante consistência entre frontend e backend
 */

/**
 * Normaliza um número de telefone removendo caracteres não numéricos e o DDI 55
 * Usa a mesma lógica do backend para garantir consistência
 */
export const normalizePhoneNumber = (phone: string): string => {
  if (!phone) return "";
  // Usar a mesma normalização do backend: remove caracteres não numéricos e remove 55 do início
  return phone.replace(/[^0-9]/g, "").replace(/^55/, "");
};

/**
 * Compara dois números de telefone normalizados
 */
export const comparePhoneNumbers = (
  phone1: string,
  phone2: string,
): boolean => {
  return normalizePhoneNumber(phone1) === normalizePhoneNumber(phone2);
};

/**
 * Obtém o número de telefone principal de uma conversa
 */
export const getConversationPhone = (conversation: any): string => {
  return conversation?.valid_telephone || conversation?.telephone || "";
};

/**
 * Obtém o número de telefone normalizado de uma conversa
 */
export const getNormalizedConversationPhone = (conversation: any): string => {
  return normalizePhoneNumber(getConversationPhone(conversation));
};
